// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Stack, Text, Button, Center } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  message?: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, title, message, action }: EmptyStateProps) {
  return (
    <Center py="xl">
      <Stack ta="center" gap="sm">
        {icon || (
          <IconInbox
            size={48}
            stroke={1.5}
            color="var(--mantine-color-dimmed)"
          />
        )}
        <Text fw={500} size="lg">
          {title}
        </Text>
        {message && (
          <Text c="dimmed" size="sm" ta="center" maw={400}>
            {message}
          </Text>
        )}
        {action && (
          <Button variant="light" mt="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </Stack>
    </Center>
  );
}
